import router from "../axios";
import config from "../../config/index"
const { baseUrl } = config;

function getMenuTree(data) {
  // 获取所有菜单列表，包含当前用户的可见状态
  return router({
    url: baseUrl + "menu/v1/treeList",
    data: data,
    method: "POST",
  });
}

function getRoleMenuList(data) {
  // 获取路由（后端根据缓存token返回当前用户所有权限的菜单）
  return router({
    url: baseUrl + "menu/v1/menuList",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}


// 新增菜单
function createMenu(data) {
  return router({
    url: baseUrl + "menu/v1/create",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 修改菜单
function updateMenu(data) {
  return router({
    url: baseUrl + "menu/v1/update",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 逻辑删除菜单
function deleteMenu(data) {
  return router({
    url: baseUrl + "menu/v1/delete",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

// 物理删除菜单
function physicalDeleteMenu(data) {
  return router({
    url: baseUrl + "menu/v1/physicalDeleteMenu",
    data: data,
    method: "POST",
    header: {
      'Content-Type': 'application/json'
    }
  });
}

export {
  getMenuTree,
  getRoleMenuList,
  createMenu,
  updateMenu,
  deleteMenu,
  physicalDeleteMenu,
}